import { render, staticRenderFns } from "./CannedNoteForm.vue?vue&type=template&id=0454e99a"
import script from "./CannedNoteForm.vue?vue&type=script&lang=js"
export * from "./CannedNoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports